import React, { useCallback, useEffect, useState } from 'react';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import adsApi from './adsApi';

export default function AdsPlacementsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await adsApi.listPlacements();
      setItems(res?.data || []);
    } catch (err) {
      setError(err.message || 'Failed to load placements');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const update = async (id, patch) => {
    try {
      await adsApi.updatePlacement(id, patch);
      await load();
    } catch (err) {
      setError(err.message || 'Update failed');
    }
  };

  if (loading) return <LoadingSpinner size="large" message="Loading placements..." />;

  return (
    <div className="space-y-6 p-4 md:p-6">
      <h1 className="text-2xl font-bold text-slate-900">Ad Placements</h1>
      {error ? (
        <div className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>
      ) : null}
      <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr>
              <th className="px-3 py-2">Code</th>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Page</th>
              <th className="px-3 py-2">AdSense</th>
              <th className="px-3 py-2">AdSense slot</th>
              <th className="px-3 py-2">Active</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => (
              <tr key={row.id} className="border-t border-slate-100">
                <td className="px-3 py-2 font-mono text-xs">{row.code}</td>
                <td className="px-3 py-2">{row.name}</td>
                <td className="px-3 py-2">{row.page_key}</td>
                <td className="px-3 py-2">
                  <input
                    type="checkbox"
                    checked={!!row.allows_adsense}
                    onChange={(e) => update(row.id, { allows_adsense: e.target.checked })}
                  />
                </td>
                <td className="px-3 py-2">
                  <input
                    className="w-40 rounded border border-slate-300 px-2 py-1 text-xs"
                    defaultValue={row.adsense_slot_id || ''}
                    onBlur={(e) => {
                      if (e.target.value !== (row.adsense_slot_id || '')) {
                        update(row.id, { adsense_slot_id: e.target.value || null });
                      }
                    }}
                    placeholder="ca-pub-slot"
                  />
                </td>
                <td className="px-3 py-2">
                  <input
                    type="checkbox"
                    checked={!!row.is_active}
                    onChange={(e) => update(row.id, { is_active: e.target.checked })}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
